export const DEFAULT_CATEGORY = 'Todos';
